import React, { useState } from "react";
import SignatureFormatter from "./components/SignatureFormatter";
import "./style.css";
import Select from 'react-select'

const Wrapper = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const Container = {
  width: "100%",
  display: "block",
};
const InputWrapper = {
  margin: "0 0",
  paddingTop: "20px",
};
const leftPart = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
}
const inputWrapper = {
  display: "flex",
  flexDirection: "row",
  gap: "15px"
}
const options = [
  { value: "acheteur", label: "Acheteur"},
  { value: "agent-polyvalente-de-restauration", label: "Agent polyvalente de restauration"},
  { value: "aide-metallier", label: "Aide métallier"},
  { value: "approvisionneur", label: "Approvisionneur"},
  { value: "coordinateur-qse", label: "Coordinateur QSE"},
  { value: "apprenti-electricien", label: "Apprenti Electricien"},
  { value: "apprenti-ingenieur", label: "Apprenti Ingénieur"},
  { value: "câbleur", label: "Câbleur"},
  { value: "charge-d'affaires", label: "Chargé d'Affaires"},
  { value: "charge-de-travaux", label: "Chargé de Travaux"},
  { value: "chargee-d'administration-et-planification", label: "Chargée d'Administration et Planification"},
  { value: "chef-d'equipe", label: "Chef d'Equipe"},
  { value: "chef-d'equipe-atelier", label: "Chef d'Equipe Atelier"},
  { value: "chef-d'equipe-magasin", label: "Chef d'Equipe Magasin"},
  { value: "chef-d'equipe-metallerie", label: "Chef d'Equipe Métallerie"},
  { value: "chef-de-projet", label: "Chef de Projet"},
  { value: "comptable", label: "Comptable"},
  { value: "coordinateur-maintenance", label: "Coordinateur Maintenance"},
  { value: "dessinateur-projeteur", label: "Dessinateur Projeteur"},
  { value: "directeur-general", label: "Directeur Général"},
  { value: "employe-service-facturation", label: "Employé Service Facturation"},
  { value: "ingenieur-d'etudes", label: "Ingénieur d'Etudes"},
  { value: "ingenieur-d'etudes-automatismes", label: "Ingénieur d'Etudes Automatismes"},
  { value: "magasinier", label: "Magasinier"},
  { value: "magasinier-chauffeur", label: "Magasinier-Chauffeur"},
  { value: "metallier", label: "Métallier"},
  { value: "monteur-electricien", label: "Monteur Electricien"},
  { value: "responsable-informatique", label: "Responsable Informatique"},
  { value: "responsable-achats-et-logistique", label: "Responsable Achats et Logistique"},
  { value: "responsable-administratif-et-financier", label: "Responsable Administratif et Financier"},
  { value: "responsable-bureau-d'etudes", label: "Responsable Bureau d'Etudes"},
  { value: "responsable-chantiers", label: "Responsable Chantiers"},
  { value: "responsable-d'activite", label: "Responsable d'Activité"},
  { value: "responsable-d'affaires", label: "Responsable d'Affaires"},
  { value: "responsable-facturation", label: "Responsable Facturation"},
  { value: "responsable-maintenance", label: "Responsable Maintenance"},
  { value: "responsable-paie", label: "Responsable Paie"},
  { value: "responsable-qse", label: "Responsable QSE"},
  { value: "responsable-rh", label: "Responsable RH"},
  { value: "responsable-travaux", label: "Responsable Travaux"},
  { value: "responsable-travaux-adjoint", label: "Responsable Travaux adjoint"},
  { value: "assistante-technique-et-commerciale", label: "Assistante technique et commerciale"},
  { value: "assistante-administrative-et-technique", label: "Assistante administrative et technique"},
  { value: "technicien-courant-faible", label: "Technicien courant faible"},
  { value: "technicien-d'etudes", label: "Technicien d'études"},
  { value: "technicien-d'etudes-automatismes", label: "Technicien d'études Automatismes"},
  { value: "technicien-de-maintenance", label: "Technicien de Maintenance"},
];

// default data to print
const userData = {
  firstname: "Prénom",
  lastname: "Nom",
  urlImage: "",
  job: "Titre du poste",
  availability: 'Description du poste',
  mobile: "",
  phone: "",
  office_phone: "03 88 19 73 73",
  postalAdress: "16 rue Lamartine, 67300 Schiltigheim",
  email: "nom@loeber.fr",
  website: "www.loeber.fr",
};

export default function App() {
  const [user, setUser] = useState(userData);
  const [isChecked, setIsChecked] = useState(false);
  const [typeImage, setTypeImage] = useState('static');

  const handleImageChange = (e) => {
    setUser({ ...user, "job": e.label });
  };

  const handleOnChange = e => {
    const { name, value } = e.target;
    setIsChecked(!isChecked);
  };

  const userInfoChange = e => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  function copyToClipboard() {
    let tableToCopy = document.querySelector('.wrapper-table')
    let range = document.createRange();
    range.selectNode(tableToCopy);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  function responseCopy() {
    let button = document.querySelector('button');
      button.classList.add('copied');
    setTimeout(() => {
      button.classList.remove('copied');
    }, 2000);
  }

  return (
    <div style={Wrapper}>
      <div style={Container}>
        <section className="formulaire">
          <div style={leftPart}>
            <SignatureFormatter user={user} message={isChecked} typeImage={typeImage} />
          </div>
          <div className="rightPart">
            <h1 className="title">Loeber - Signature mail</h1>
            <p className="inputLabel">Noms</p>

            {/* INPUT RIGHT SIDE  */}

            {/* ***************          NOM ET PRENOM        *************** */}
            <div style={inputWrapper}>
              <input
                name="lastname"
                onChange={userInfoChange}
                value={user.lastname}
                placeholder="Nom"
                onBlur={() => {
                  user.lastname === "" ? setUser({ ...user, lastname: userData.lastname }) : setUser({ ...user, lastname: user.lastname });
                }}
                onFocus={() => {
                  user.lastname === userData.lastname ? setUser({ ...user, lastname: "" }) : setUser({ ...user, lastname: user.lastname });
                }}
              />
              <input
                name="firstname"
                onChange={userInfoChange}
                value={user.firstname}
                placeholder="Prénom"
                onBlur={() => {
                  user.firstname === "" ? setUser({ ...user, firstname: userData.firstname }) : setUser({ ...user, firstname: user.firstname });
                }}
                onFocus={() => {
                  user.firstname === userData.firstname ? setUser({ ...user, firstname: "" }) : setUser({ ...user, firstname: user.firstname });
                }}
              />
            </div>

            {/* ***************          TITRE DU POSTE        *************** */}
            <div className="selectJob">
              <Select
              options={options}
              onChange={handleImageChange}
              placeholder="Votre poste"
              />
            </div>



            <p className="inputLabel">Coordonnées</p>
            {/* ***************          ADRESSE POSTALE        *************** */}
            <div style={InputWrapper}>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdress}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdress === "" ? setUser({ ...user, postalAdress: userData.postalAdress }) : setUser({ ...user, postalAdress: user.postalAdress });
                }}
                onFocus={() => {
                  user.postalAdress === userData.postalAdress ? setUser({ ...user, postalAdress: "" }) : setUser({ ...user, postalAdress: user.postalAdress });
                }}
              />
            </div>

            {/* ***************          ADRESSE EMAIL        *************** */}
            <div style={InputWrapper}>
              <input
                name="email"
                onChange={userInfoChange}
                value={user.email}
                placeholder="Adresse email"
                onBlur={() => {
                  user.email === "" ? setUser({ ...user, email: userData.email }) : setUser({ ...user, email: user.email });
                }}
                onFocus={() => {
                  user.email === userData.email ? setUser({ ...user, email: "" }) : setUser({ ...user, email: user.email });
                }}
              />
            </div>

            {/* ***************          TELEPHONE        *************** */}
            <div style={InputWrapper}>
              <input
                name="phone"
                onChange={userInfoChange}
                value={user.phone}
                placeholder="Téléphone (ligne directe)"
                onBlur={() => {
                  user.phone === "" ? setUser({ ...user, phone: userData.phone }) : setUser({ ...user, phone: user.phone });
                }}
                onFocus={() => {
                  user.phone === userData.phone ? setUser({ ...user, phone: "" }) : setUser({ ...user, phone: user.phone });
                }}
              />
            </div>

            {/* ***************          FAX        *************** */}
            <div style={InputWrapper}>
              <input
                name="office_phone"
                onChange={userInfoChange}
                value={user.office_phone}
                placeholder="Téléphone bureau"
                onBlur={() => {
                  user.office_phone === "" ? setUser({ ...user, office_phone: userData.office_phone }) : setUser({ ...user, office_phone: user.office_phone });
                }}
                onFocus={() => {
                  user.office_phone === userData.office_phone ? setUser({ ...user, office_phone: "" }) : setUser({ ...user, office_phone: user.office_phone });
                }}
              />
            </div>
            <div style={InputWrapper}>
              <input
                name="mobile"
                onChange={userInfoChange}
                value={user.mobile}
                placeholder="Téléphone mobile"
                onBlur={() => {
                  user.mobile === "" ? setUser({ ...user, mobile: userData.mobile }) : setUser({ ...user, mobile: user.mobile });
                }}
                onFocus={() => {
                  user.mobile === userData.mobile ? setUser({ ...user, mobile: "" }) : setUser({ ...user, mobile: user.mobile });
                }}
              />
            </div>



            {/* ***************          SITE INTERNET        *************** */}
            <p className="inputLabel">Site internet</p>
            <div style={InputWrapper}>
              <input
                name="website"
                onChange={userInfoChange}
                value={user.website}
                placeholder="Site internet"
                onBlur={() => {
                  user.website === "" ? setUser({ ...user, website: userData.website }) : setUser({ ...user, website: user.website });
                }}
                onFocus={() => {
                  user.website === userData.website ? setUser({ ...user, website: "" }) : setUser({ ...user, website: user.website });
                }}
              />
            </div>



            {/* ***************          IMAGE        *************** */}
            <p className="inputLabel">Image</p>

            {/* ***************          CENTRER IMAGE        *************** */}
            <div className="checkItem">
              <input
                type="checkbox"
                id="topping"
                name="topping"
                value="Paneer"
                checked={isChecked}
                onChange={handleOnChange}
              />
            </div>

            {/* ***************          IMAGE STATIQUE OU GIF        *************** */}

            <button
              className="copyButton"
              onClick={() => {
                copyToClipboard();
                responseCopy();
              }}
            >
              <p className="btnCopy"></p>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
